<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter">
<h2><span class="h2-inner">Letter from Cato’s papers, preserved in the archives of Rome</span></h2>
<p class="firstInSection"><em>To Marcus Porcius Cato, Censor, in Rome; Quintus Vitellius Tancinus, special legate, sends greetings from Sicily</em>. I have followed your orders to the letter. Leaving Rome, and satisfied that no persons matching your description of them had sailed from Ostia, I enquired at all the harbours of the south-western littoral: Misenum, Neapolis, Posidonia, Elea and Rhegium. I could find no trace of them. So I assumed that this Bostar and the bastard Hanno had not, as you feared, gone south to Carthage.</p>
<p>Still, I crossed to Sicily and, using your warrant and your gold, asked at Panormus and Messana. Nothing. At Agrigentum and Gela. Nothing. Only in Syracuse did I find good – and expensive – news. A galley called the <em>Apollodorus</em>, double-oared and fast, its master one Trimalchio, a Ligurian. This Bostar chartered her some five months ago. Trimalchio did not leave an itinerary with the harbourmaster as he should have done. But all my sources are agreed: the <em>Apollodorus</em> sailed east, with enough provisions for a long journey. I questioned the port’s quartermaster. He remembered the transaction clearly. Among other strange things, this Bostar insisted on a large package of that strange gum, <em>bdellium.</em> Where have they gone? To Achaea, Epirus or Macedonia? Asia, Lycia or even Bithynia where, they say, that savage Hannibal hides? If you want me to search in the east, I suggest I take ship to Athens. You say this Bostar is a philhellene. Wherever he has gone he will have wanted, I believe, to refill the ship’s water barrels there. I await your orders. By the hand of him who bears this, send them to me at the house of Pollius by the harbour wall – and send me more gold.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?ae2448a6